import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import ArticleDetail from "../pages/article/page";
import Search from "../pages/search/page";
import AdminLogin from "../pages/admin/page";
import AdminDashboard from "../pages/admin/dashboard/page";
import AdminEdit from "../pages/admin/edit/page";
import AdminAccounts from "../pages/admin/accounts/page";
import CategoryPage from "../pages/category/page";
import SugarAwayV4Page from "../pages/sugaraway-v4/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/category/:slug",
    element: <CategoryPage />,
  },
  {
    path: "/article/:slug",
    element: <ArticleDetail />,
  },
  {
    path: "/sugaraway-v4",
    element: <SugarAwayV4Page />,
  },
  {
    path: "/search",
    element: <Search />,
  },
  {
    path: "/admin",
    element: <AdminLogin />,
  },
  {
    path: "/admin/dashboard",
    element: <AdminDashboard />,
  },
  {
    path: "/admin/accounts",
    element: <AdminAccounts />,
  },
  {
    path: "/admin/edit/:slug",
    element: <AdminEdit />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;